import { render, staticRenderFns } from "./dietInterpret.vue?vue&type=template&id=00284d81&scoped=true"
import script from "./dietInterpret.vue?vue&type=script&lang=js"
export * from "./dietInterpret.vue?vue&type=script&lang=js"
import style0 from "./dietInterpret.vue?vue&type=style&index=0&id=00284d81&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00284d81",
  null
  
)

export default component.exports